import { orchestrator } from 'satcheljs';
import { hasActiveDrawerPane, drawerPaneShownChanged } from 'owa-drawer';
import { onAvailableWidthBucketChanged } from '../actions/onAvailableWidthBucketChanged';
import LayoutChangeSource from '../store/schema/LayoutChangeSource';
import calculateAvailableWidthBucket from '../utils/calculateAvailableWidthBucket';
import { updateFlexPaneInternalWidth } from '../utils/updateFlexPaneInternalWidth';
import { getAreDisplayAdsEnabled } from '../selectors/getAreDisplayAdsEnabled';
import { setBrowserWidthBucket } from '../actions/setAvailableHeightAndWidthBuckets';

orchestrator(drawerPaneShownChanged, actionMessage => {
    const { paneId, targetWindow, isShown } = actionMessage;

    // Layout bucket system is main-window only.
    // Pop-out windows have their own simpler layout and don't participate in bucket calculations.
    const isMainWindow = targetWindow === window;

    if (isMainWindow) {
        // Use hasActiveDrawerPane (not actionMessage.isShown) because another pane may still
        // be open when this pane closes. hasActiveDrawerPane checks all entries, not just this one.
        const shouldSubtractFlexPaneWidth = hasActiveDrawerPane(targetWindow);

        const newAvailableWidthBucket = calculateAvailableWidthBucket(
            false /* skipCache */,
            getAreDisplayAdsEnabled(),
            shouldSubtractFlexPaneWidth,
            paneId
        );

        setBrowserWidthBucket(newAvailableWidthBucket);
        onAvailableWidthBucketChanged(
            newAvailableWidthBucket,
            LayoutChangeSource.OwaSuiteHeaderFlexPane
        );
    }

    // CSS variable update is per-window — update on both open and close
    updateFlexPaneInternalWidth(isShown ? paneId : undefined, targetWindow);
});
